export class FormUtils {
  public static extractValues($form: HTMLFormElement): Record<string, string> {
    const formData = new FormData($form);
    return Object.fromEntries(formData.entries()) as Record<string, string>;
  }
}
